var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VideoPlayer',{ref:"hlsPlayer",staticClass:"vjs-custom-skin",attrs:{"options":_vm.options},on:{"statechanged":_vm.playerStateChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }